import { cn } from '@bem-react/classname';

export const cnTextinput = cn('Textinput');
